// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '9df95aa8-173c-4fb3-991f-d0f30462edb3',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '56f207de-9721-471f-8757-9a2d8ac18183',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Toggle_BG_Off',
      parent: '9df95aa8-173c-4fb3-991f-d0f30462edb3',
      data: undefined,
      stateByName: {
        on: {
          texture: 'UI_Toggle_BG_On'
        }
      }
    },
    {
      id: 'bc0a2a21-0f9a-4a54-a877-53b48ebec332',
      type: 'Sprite',
      runtimeType: null,
      name: 'knob',
      className: '',
      x: 23,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Toggle_Knob',
      parent: '9df95aa8-173c-4fb3-991f-d0f30462edb3',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'on',
    'off'
  ],
  animations: []
} as const;

export class SettingsToggleLayout {
  static raw = raw;
  root: Container;
  knob: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'on' | 'off';
    ModelByName: {
      root: typeof raw['list'][0];
      knob: typeof raw['list'][3];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
